import React from 'react';
import styled from 'styled-components/macro';

import { distances } from '../../../styles/constants';
import Dropdown, { DropdownOption } from '../../../components/Forms/Dropdown';
import { InputValidation } from '../../../components/Forms';

import { Label } from '../../../components/Typography';

export interface CurrencyDropdownProps {
    value: string;
    name: string;
    options: string[];
    label: string;
    placeholder: string;
    onChange: (value: string) => void;
    validation?: InputValidation;
}

const CurrencyDropdown = (
    {
        label,
        name,
        value,
        options,
        onChange,
    }: CurrencyDropdownProps
) => {
    const dropdownOptions: DropdownOption[] = options
        .map((value) => ({
            label: value,
            value,
        }))
        .sort((a, b) => {
            return a.label.localeCompare(b.label);
        });
    const selectedOption = dropdownOptions.find((option) => option.value === value);
    return (
        <Wrapper>
            <Label htmlFor={name}>{label}</Label>
            {selectedOption && (
                <Dropdown
                    name={name}
                    value={selectedOption}
                    options={dropdownOptions}
                    onChange={(val) => {
                        onChange(val.value);
                    }}
                />
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: relative;
    width: 100%;
`;

export default CurrencyDropdown;
